import React from 'react';

// ============================================================================
// Types
// ============================================================================

export type Direction = 'top' | 'right' | 'bottom' | 'left';
export type ArrowLocation =
  | 'default'
  | 'middle'
  | 'left'
  | 'right'
  | 'top'
  | 'bottom';
export type TooltipRefs = HTMLDivElement | HTMLButtonElement;

export interface Position {
  top: number;
  left: number;
}

export interface OutOfBounds {
  left: boolean;
  right: boolean;
  top: boolean;
  bottom: boolean;
}

export interface TooltipProps {
  show?: boolean;
  direction?: Direction;
  arrowLocation?: ArrowLocation;
  children: React.ReactNode;
  className?: string;
  maxWidth?: string;
  targetRef?: React.RefObject<HTMLElement | null>;
  customPosition?: {
    top?: string | number;
    left?: string | number;
    right?: string | number;
    bottom?: string | number;
  };
  portal?: boolean;
}

export interface PortalTooltipProps {
  show: boolean;
  direction: Direction;
  arrowLocation: ArrowLocation;
  children: React.ReactNode;
  className?: string;
  maxWidth?: string;
  targetRef?: React.RefObject<HTMLElement | null>;
  forwardedRef?: React.ForwardedRef<TooltipRefs>;
}

// ============================================================================
// Constants
// ============================================================================

export const SPACING = {
  gap: 8,
  screenPadding: 16,
};

export const ARROW_INSET_PX = 14;
